import type { Release } from '../releases';

export default {
  id: '2026-11-03-change-chain',
  at: '2026-11-04T09:48:00Z',
  title: 'Утверждённое изменение само создаёт версию сметы и предлагает изменение бюджета',
  modules: ['changes', 'estimates', 'budget'],
  items: [
    'Когда запрос на изменение утверждён, каждая связанная смета получает новую версию-черновик с причиной и ссылкой на запрос — сметчику остаётся внести правки.',
    'Если запрос меняет себестоимость и связан с одним разделом утверждённого бюджета, в бюджет сразу предлагается изменение этого раздела на ту же сумму с основанием «запрос на изменение»; утверждает его тот, кто утверждает бюджет.',
    'Это происходит один раз на запрос, в том числе когда последний шаг согласовал заказчик в своём кабинете. Что сделано, видно в журнале запроса.',
  ],
  why: 'После утверждения изменения смету и бюджет правили вручную по поручениям, и часть правок терялась или делалась дважды.',
  link: '/changes',
} satisfies Release;
